<template>
  <div>
    <v-list-item :style="itemStyle">
      <div
        style="width: 32px; display: flex; justify-content: center"
        @click="
          $router.push(item.routeTo).catch((error) => {
            if (
              error.name !== 'NavigationDuplicated' &&
              !error.message.includes(
                'Avoided redundant navigation to current location'
              )
            ) {
              console.log(error);
            }
          })
        "
      >
        <v-icon :class="active ? 'sidebar-active-icon' : 'sidebar-icon'">{{
          item.icon
        }}</v-icon>
      </div>

      <v-list-item-content
        @click="
          $router.push(item.routeTo).catch((error) => {
            if (
              error.name !== 'NavigationDuplicated' &&
              !error.message.includes(
                'Avoided redundant navigation to current location'
              )
            ) {
              console.log(error);
            }
          })
        "
      >
        <v-list-item-title
          :class="active ? 'sidebar-active-text' : 'sidebar-text'"
          style="margin-right: 20px"
          >{{ item.text }}</v-list-item-title
        >
      </v-list-item-content>

      <v-icon
        v-if="item.childItems"
        @click="openChildList = !openChildList"
        class="sidebar-icon"
        :style="iconStyle"
        >fa-chevron-down</v-icon
      >
    </v-list-item>

    <v-slide-y-transition>
      <v-list v-if="item.childItems && openChildList" style="padding: 0">
        <item
          v-for="(item, i) in item.childItems"
          :key="i"
          :item="item"
          :level="level + 1"
        />
      </v-list>
    </v-slide-y-transition>
  </div>
</template>

<script>
export default {
  name: "item",

  data: () => ({
    openChildList: false,
    active: false,
  }),

  props: ["item", "level"],

  computed: {
    itemStyle() {
      return {
        "margin-left": `${this.level * 20}px`,
        display: "flex",
        "justify-content": "space-between",
        padding: "5px 0 !important",
        "border-bottom": "solid 1px #64c832",
        cursor: "pointer",
      };
    },

    iconStyle() {
      return {
        transition: "all 0.3s ease-in-out",
        transform: `rotate(${this.openChildList ? "-180" : "0"}deg)`,
      };
    },
  },
};
</script>

<style scoped>
.sidebar-icon {
  color: var(--v-primary-base) !important;

  margin: 0 10px 0 0;

  font-size: 1.2em !important;
}

.sidebar-active-icon {
  color: #ffcd00 !important;

  margin: 0 10px 0 0;

  font-size: 1.2em !important;
}

.sidebar-text {
  color: var(--v-primary-base);
}

.sidebar-active-text {
  color: #ffcd00;
}
</style>
